import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_slot_85c2da36__ from "@radix-ui/react-slot";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import * as __WEBPACK_EXTERNAL_MODULE_clsx__ from "clsx";
import * as __WEBPACK_EXTERNAL_MODULE_tailwind_merge_e05e3e95__ from "tailwind-merge";
import * as __WEBPACK_EXTERNAL_MODULE__phosphor_icons_react_e1aa837f__ from "@phosphor-icons/react";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_checkbox_76684228__ from "@radix-ui/react-checkbox";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__ from "@radix-ui/react-dialog";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_label_49d956a0__ from "@radix-ui/react-label";
import "react-dom";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_progress_84970133__ from "@radix-ui/react-progress";
import * as __WEBPACK_EXTERNAL_MODULE_lodash__ from "lodash";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__ from "@radix-ui/react-select";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_tabs_7bf5a77b__ from "@radix-ui/react-tabs";
import * as __WEBPACK_EXTERNAL_MODULE_cmdk__ from "cmdk";
import * as __WEBPACK_EXTERNAL_MODULE_fuzzysort__ from "fuzzysort";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_popover_e2827c9f__ from "@radix-ui/react-popover";
function cn(...inputs) {
    return (0, __WEBPACK_EXTERNAL_MODULE_tailwind_merge_e05e3e95__.twMerge)((0, __WEBPACK_EXTERNAL_MODULE_clsx__.clsx)(inputs));
}
const badgeVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)('shrink-0 line-clamp-1 inline-flex border text-xs items-center', {
    variants: {
        variant: {
            default: 'border-neutral-normal-default bg-layer-accent-prominent-fixed-default text-brand-foreground-mid',
            secondary: 'border-neutral-normal-default bg-layer-neutral-subtle-default text-neutral-normal-default',
            none: 'border-none',
            destructive: 'border-neutral-normal-default bg-layer-danger-prominent-fixed-default text-white-prominent-fixed-default',
            outline: 'border-accent-normal-fixed-default bg-layer-accent-subtle-fixed-default text-accent-normal-default',
            secondary_outline: 'border-neutral-prominent-default bg-layer-neutral-prominent-default text-neutral-normal-default',
            info: 'info',
            warning: 'warning',
            success: 'success',
            destructive_outline: 'border-danger-subtle-fixed-default text-danger-normal-default bg-layer-danger-subtle-fixed-default',
            prominent_outline: 'border-border bg-layer-neutral-prominent text-neutral-normal-default',
            mainNav: 'caption-xs text-white/60 bg-brand-500/20 group-hover:bg-brand-500/30 group-hover:text-white transition-all rounded-xs shadow-[0_0_4px_0_hsl(var(--brand-500))] !px-1'
        },
        size: {
            default: 'px-1 py-0.5 rounded-xs gap-1 h-5',
            xs: 'px-0.5 py-0 rounded-xs gap-0.5 h-4',
            lg: 'text-base px-1 rounded-sm',
            inline: 'py-0.5 gap-1 h-5'
        }
    },
    defaultVariants: {
        variant: 'default',
        size: 'default'
    }
});
const Badge = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, variant, size, asChild, ...props }, ref)=>{
    const Comp = asChild ? __WEBPACK_EXTERNAL_MODULE__radix_ui_react_slot_85c2da36__.Slot : 'div';
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Comp, {
        className: cn(badgeVariants({
            variant,
            size,
            className
        })),
        ref: ref,
        ...props
    });
});
const badge_Badge = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Badge, {
        ref: ref,
        ...props
    }));
const buttonVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)([
    'inline-flex',
    'shrink',
    'gap-2',
    'items-center',
    'group',
    'justify-center',
    'whitespace-nowrap',
    'rounded-md',
    'text-sm',
    'font-medium',
    'ring-offset-background',
    'transition-colors',
    'focus-visible:outline-hidden',
    'focus-visible:ring-2',
    'focus-visible:ring-ring',
    'focus-visible:ring-offset-2',
    'disabled:pointer-events-none',
    'cursor-pointer'
], {
    variants: {
        variant: {
            default: [
                'border',
                'border-neutral-prominent-default',
                'bg-layer-accent-prominent-fixed-default',
                'hover:bg-layer-accent-prominent-fixed-hover',
                'active:bg-layer-accent-prominent-fixed-active',
                'focus:bg-layer-accent-prominent-fixed-focus',
                'disabled:bg-layer-accent-prominent-fixed-disabled',
                'text-brand-foreground-mid',
                'disabled:text-brand-foreground-mid-disabled'
            ],
            destructive: [
                'border',
                'border-neutral-prominent-default',
                'bg-layer-danger-prominent-fixed-default',
                'text-white-prominent-fixed-default',
                'hover:bg-layer-danger-prominent-fixed-hover',
                'active:bg-layer-danger-prominent-fixed-active',
                'disabled:bg-layer-danger-prominent-fixed-disabled',
                'disabled:text-white-prominent-fixed-disabled'
            ],
            outline: [
                'border',
                'border-neutral-prominent-default',
                'bg-layer-neutral-normal-default',
                'text-neutral-normal-default',
                'hover:bg-layer-neutral-normal-hover',
                'hover:text-neutral-normal-hover',
                'active:bg-layer-neutral-normal-active',
                'active:text-neutral-normal-active',
                'disabled:text-neutral-normal-disabled'
            ],
            secondary: [
                'bg-layer-neutral-subtle-default',
                'text-neutral-normal-default',
                'hover:bg-layer-neutral-subtle-hover',
                'hover:text-neutral-normal-hover',
                'active:bg-layer-neutral-subtle-active',
                'active:text-neutral-normal-active',
                'disabled:text-neutral-normal-disabled'
            ],
            ghost: [
                'bg-transparent',
                'text-neutral-normal-default',
                'hover:bg-layer-neutral-normal-hover',
                'hover:text-neutral-normal-hover',
                'active:bg-layer-neutral-normal-active',
                'active:text-neutral-normal-active',
                'disabled:text-neutral-normal-disabled'
            ],
            link: [
                'text-accent-normal-default',
                'hover:text-accent-normal-hover',
                'active:text-accent-normal-active',
                'disabled:text-accent-normal-disabled',
                'underline-offset-4',
                'hover:underline'
            ],
            link_neutral: [
                'text-neutral-normal-default',
                'hover:text-neutral-normal-hover',
                'active:text-neutral-normal-active',
                'disabled:text-neutral-normal-disabled',
                'underline-offset-4',
                'hover:underline'
            ]
        },
        size: {
            inline: 'text-[1em]',
            default: 'p-2 h-7 gap-1 rounded-md',
            xs: 'min-h-4 rounded-sm px-1.5 py-1 text-xs gap-1',
            sm: 'h-9 rounded-md px-3',
            lg: 'h-11 rounded-md px-8',
            icon: 'h-7 w-7 shrink-0',
            card: 'flex flex-col items-start justify-start text-left group whitespace-normal [overflow-wrap:anywhere]',
            count: 'h-7 px-3 py-1'
        }
    },
    defaultVariants: {
        variant: 'default',
        size: 'default'
    }
});
const Button = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, variant, size, asChild = false, ...props }, ref)=>{
    const Comp = asChild ? __WEBPACK_EXTERNAL_MODULE__radix_ui_react_slot_85c2da36__.Slot : 'button';
    const extraProps = 'button' === Comp ? {
        type: 'button'
    } : {};
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Comp, {
        className: cn(buttonVariants({
            variant,
            size,
            className
        })),
        ref: ref,
        ...extraProps,
        ...props
    });
});
Button.displayName = 'Button';
const button_Button = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Button, {
        ref: ref,
        ...props
    }));
const Breadcrumb = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("nav", {
        "aria-label": "breadcrumb",
        ref: ref,
        ...props
    }));
Breadcrumb.displayName = 'Breadcrumb';
const BreadcrumbList = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("ol", {
        className: cn('flex items-center gap-0.5 truncate text-sm break-words text-neutral-subtle-default', className),
        ref: ref,
        ...props
    }));
BreadcrumbList.displayName = 'BreadcrumbList';
const BreadcrumbItem = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("li", {
        className: cn('inline-flex items-center gap-0.5 truncate rounded-xs text-xs font-medium ring-offset-background transition-colors focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden', className),
        ref: ref,
        ...props
    }));
BreadcrumbItem.displayName = 'BreadcrumbItem';
const BreadcrumbLink = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ asChild, className, ...props }, ref)=>{
    const Comp = asChild ? __WEBPACK_EXTERNAL_MODULE__radix_ui_react_slot_85c2da36__.Slot : 'a';
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Comp, {
        className: cn('truncate rounded-xs p-1 ring-offset-background transition-colors hover:bg-layer-neutral-prominent-hover hover:text-neutral-prominent-hover focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden active:bg-layer-neutral-prominent-active', className),
        ref: ref,
        ...props
    });
});
BreadcrumbLink.displayName = 'BreadcrumbLink';
const BreadcrumbPage = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
        "aria-current": "page",
        "aria-disabled": "true",
        className: cn('truncate py-1 font-normal text-neutral-prominent-default', className),
        ref: ref,
        role: "link",
        ...props
    }));
BreadcrumbPage.displayName = 'BreadcrumbPage';
const BreadcrumbSeparator = ({ children, className, ...props })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("li", {
        "aria-hidden": "true",
        className: cn('[&>svg]:size-3.5', className),
        role: "presentation",
        ...props,
        children: children ?? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__phosphor_icons_react_e1aa837f__.CaretRight, {})
    });
BreadcrumbSeparator.displayName = 'BreadcrumbSeparator';
const BreadcrumbEllipsis = ({ className, ...props })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("span", {
        "aria-hidden": "true",
        className: cn('flex size-9 items-center justify-center', className),
        role: "presentation",
        ...props,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__phosphor_icons_react_e1aa837f__.DotsThree, {
                className: "size-4"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                className: "sr-only",
                children: "More"
            })
        ]
    });
BreadcrumbEllipsis.displayName = 'BreadcrumbElipssis';
const breadcrumb_Breadcrumb = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Breadcrumb, {
        ref: ref,
        ...props
    }));
const breadcrumb_BreadcrumbList = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BreadcrumbList, {
        ref: ref,
        ...props
    }));
const breadcrumb_BreadcrumbItem = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BreadcrumbItem, {
        ref: ref,
        ...props
    }));
const breadcrumb_BreadcrumbLink = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BreadcrumbLink, {
        ref: ref,
        ...props
    }));
const breadcrumb_BreadcrumbPage = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BreadcrumbPage, {
        ref: ref,
        ...props
    }));
const breadcrumb_BreadcrumbSeparator = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BreadcrumbSeparator, {
        ref: ref,
        ...props
    }));
const breadcrumb_BreadcrumbEllipsis = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BreadcrumbEllipsis, {
        ref: ref,
        ...props
    }));
const Card = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ asChild, className, ...props }, ref)=>{
    const Comp = asChild ? __WEBPACK_EXTERNAL_MODULE__radix_ui_react_slot_85c2da36__.Slot : 'div';
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Comp, {
        className: cn('rounded-lg border bg-layer-neutral-prominent text-neutral-prominent-default shadow-xs', className),
        ref: ref,
        ...props
    });
});
Card.displayName = 'Card';
const CardHeader = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: cn('flex flex-col space-y-1.5 p-6 pb-0', className),
        ref: ref,
        ...props
    }));
CardHeader.displayName = 'CardHeader';
const CardTitle = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("h3", {
        className: cn(className),
        ref: ref,
        ...props
    }));
CardTitle.displayName = 'CardTitle';
const CardSubtitle = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: cn('text-sm font-semibold text-neutral-subtle', className),
        ref: ref,
        ...props
    }));
CardTitle.displayName = 'CardSubtitle';
const CardDescription = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: cn('text-sm text-neutral-subtle-default', className),
        ref: ref,
        ...props
    }));
CardDescription.displayName = "CardDescription";
const CardContent = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: cn('p-6', className),
        ref: ref,
        ...props
    }));
CardContent.displayName = 'CardContent';
const CardFooter = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: cn('flex items-center gap-2 border-t border-neutral-normal-default px-6 py-4', className),
        ref: ref,
        ...props
    }));
CardFooter.displayName = 'CardFooter';
const card_Card = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Card, {
        ref: ref,
        ...props
    }));
const card_CardHeader = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CardHeader, {
        ref: ref,
        ...props
    }));
const card_CardFooter = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CardFooter, {
        ref: ref,
        ...props
    }));
const card_CardTitle = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CardTitle, {
        ref: ref,
        ...props
    }));
const card_CardSubtitle = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CardSubtitle, {
        ref: ref,
        ...props
    }));
const card_CardDescription = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CardDescription, {
        ref: ref,
        ...props
    }));
const card_CardContent = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CardContent, {
        ref: ref,
        ...props
    }));
const Checkbox = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, checked, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_checkbox_76684228__.Root, {
        checked: checked,
        className: cn('peer flex size-4 shrink-0 cursor-pointer items-center justify-center rounded-xs border border-neutral-extra-default bg-layer-neutral-prominent-default text-brand-foreground-mid ring-offset-background hover:border-neutral-extra-hover hover:bg-layer-neutral-prominent-hover focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:bg-layer-accent-prominent-fixed-disabled data-[state=checked]:bg-layer-accent-prominent-fixed-default data-[state=checked]:hover:bg-layer-accent-prominent-fixed-hover data-[state=checked]:active:bg-layer-accent-prominent-fixed-active', {
            'bg-layer-accent-prominent-fixed-default hover:bg-layer-accent-prominent-fixed-hover active:bg-layer-accent-prominent-fixed-active': 'indeterminate' === checked
        }, className),
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_checkbox_76684228__.Indicator, {
            className: cn('flex items-center justify-center'),
            children: [
                true === checked && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__phosphor_icons_react_e1aa837f__.Check, {
                    className: "size-3",
                    weight: "bold"
                }),
                'indeterminate' === checked && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__phosphor_icons_react_e1aa837f__.Minus, {
                    className: "size-3",
                    weight: "bold"
                })
            ]
        })
    }));
Checkbox.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_checkbox_76684228__.Root.displayName;
const checkbox_Checkbox = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Checkbox, {
        ref: ref,
        ...props
    }));
__WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Root;
__WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Trigger;
const DialogPortal = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Portal;
__WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Close;
const DialogOverlay = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Overlay, {
        className: cn('fixed inset-0 z-50 bg-black/80 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0', className),
        ref: ref,
        ...props
    }));
DialogOverlay.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Overlay.displayName;
const dialog_DialogContent = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, children, hideClose, onClick, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(DialogPortal, {
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DialogOverlay, {
                onClick: (event)=>{
                    event.stopPropagation();
                }
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: "fixed inset-0 z-50 grid place-items-center",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Content, {
                    className: cn('grid w-full max-w-lg gap-4 overflow-auto border bg-layer-neutral-prominent-default p-6 shadow-lg duration-200 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 sm:rounded-lg', className),
                    onClick: (event)=>{
                        event.stopPropagation();
                        null == onClick || onClick(event);
                    },
                    ref: ref,
                    ...props,
                    children: [
                        children,
                        !hideClose && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Close, {
                            className: "absolute top-3 right-3 flex size-6 items-center justify-center rounded-xs text-neutral-normal-default ring-offset-background transition-opacity hover:bg-layer-neutral-normal-hover hover:text-neutral-normal-hover focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none data-[state=open]:bg-layer-neutral-normal-hover data-[state=open]:text-neutral-subtle-default",
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__phosphor_icons_react_e1aa837f__.X, {
                                    className: "size-4"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                    className: "sr-only",
                                    children: "Close"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }));
dialog_DialogContent.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Content.displayName;
const DialogHeader = ({ className, ...props })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: cn('flex flex-col space-y-1.5 text-center sm:text-left', className),
        ...props
    });
DialogHeader.displayName = 'DialogHeader';
const DialogFooter = ({ className, ...props })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: cn('flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2', className),
        ...props
    });
DialogFooter.displayName = 'DialogFooter';
const DialogTitle = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Title, {
        className: cn('text-lg leading-none font-semibold tracking-tight', className),
        ref: ref,
        ...props
    }));
DialogTitle.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Title.displayName;
const DialogDescription = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Description, {
        className: cn('text-sm text-neutral-subtle-default', className),
        ref: ref,
        ...props
    }));
DialogDescription.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Description.displayName;
const src_dialog_Dialog = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Root;
const dialog_DialogTrigger = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Trigger;
const dialog_DialogPortal = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Portal;
const dialog_DialogClose = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_dialog_6b867f3d__.Close;
const dialog_DialogOverlay = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DialogOverlay, {
        ref: ref,
        ...props
    }));
const src_dialog_DialogContent = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(dialog_DialogContent, {
        ref: ref,
        ...props
    }));
const dialog_DialogHeader = (props)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DialogHeader, {
        ...props
    });
const dialog_DialogFooter = (props)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DialogFooter, {
        ...props
    });
const dialog_DialogTitle = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DialogTitle, {
        ref: ref,
        ...props
    }));
const dialog_DialogDescription = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(DialogDescription, {
        ref: ref,
        ...props
    }));
const inputVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)('transition-colors flex h-8 w-full rounded-md border border-neutral-prominent-default bg-layer-neutral-normal-default p-2 text-sm leading-4 text-neutral-subtle-active file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-neutral-subtle-default hover:border-border-hover focus:border-border-active focus:ring-2 focus:ring-ring focus:ring-offset-1 focus:ring-offset-card focus:outline-hidden active:border-border-active disabled:cursor-not-allowed disabled:border-neutral-prominent-default disabled:text-neutral-subtle-disabled disabled:placeholder:text-neutral-subtle-disabled', {
    variants: {
        variant: {
            default: '',
            error: 'border-danger-normal-default focus:border-danger-normal-default dark:border-danger-normal-default dark:focus:border-danger-normal-default text-danger-normal-default placeholder:text-danger-normal-default focus:ring-destructive dark:focus:ring-destructive'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});
const Input = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, variant, type = 'text', ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("input", {
        className: cn(inputVariants({
            variant
        }), className),
        ref: ref,
        type: type,
        ...props
    }));
Input.displayName = 'Input';
const input_Input = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Input, {
        ref: ref,
        ...props
    }));
const labelVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)('font-medium text-neutral-normal-active peer-disabled:cursor-not-allowed peer-disabled:opacity-70');
const Label = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_label_49d956a0__.Root, {
        className: cn(labelVariants(), className),
        ref: ref,
        ...props
    }));
Label.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_label_49d956a0__.Root.displayName;
const label_Label = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Label, {
        ref: ref,
        ...props
    }));
var NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var Primitive = NODES.reduce((primitive, node)=>{
    const Node = __WEBPACK_EXTERNAL_MODULE_react__.forwardRef((props, forwardedRef)=>{
        const { asChild, ...primitiveProps } = props;
        const Comp = asChild ? __WEBPACK_EXTERNAL_MODULE__radix_ui_react_slot_85c2da36__.Slot : node;
        if ("undefined" != typeof window) window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
var NAME = "VisuallyHidden";
var VisuallyHidden = __WEBPACK_EXTERNAL_MODULE_react__.forwardRef((props, forwardedRef)=>/* @__PURE__ */ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Primitive.span, {
        ...props,
        ref: forwardedRef,
        style: {
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal",
            ...props.style
        }
    }));
VisuallyHidden.displayName = NAME;
var dist_Root = VisuallyHidden;
const spinnerVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)('flex-col items-center justify-center overflow-hidden', {
    variants: {
        show: {
            true: 'flex',
            false: 'hidden'
        },
        layout: {
            shrink: 'h-auto',
            grow: 'h-full'
        }
    },
    defaultVariants: {
        show: true,
        layout: 'grow'
    }
});
const loaderVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)('animate-spin text-accent-normal', {
    variants: {
        size: {
            xs: 'size-4',
            small: 'size-6',
            medium: 'size-8',
            large: 'size-12'
        }
    },
    defaultVariants: {
        size: 'medium'
    }
});
function Loader({ size, show, children, className }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("span", {
        className: spinnerVariants({
            show
        }),
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__phosphor_icons_react_e1aa837f__.CircleNotch, {
                className: cn(loaderVariants({
                    size
                }), className)
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(dist_Root, {
                children: "Loading..."
            }),
            children
        ]
    });
}
const loader_Loader = (props)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Loader, {
        ...props
    });
const progressVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)('relative w-full overflow-hidden', {
    variants: {
        variant: {
            gradient: 'h-3 rounded-sm border border-neutral-normal-default bg-layer-neutral-subtle-default',
            bottom: 'h-1.5 rounded-b-lg bg-layer-neutral-normal-default',
            solid: 'h-1.5 rounded-xs bg-layer-accent-subtle-fixed-default'
        }
    },
    defaultVariants: {
        variant: 'gradient'
    }
});
const progressIndicatorVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)('h-full w-full flex-1 transition-all', {
    variants: {
        variant: {
            gradient: 'rounded-xs bg-linear-to-r from-brand-800 to-brand-600',
            bottom: ' border-r border-neutral-normal-default',
            solid: 'rounded-xs outline -outline-offset-1 outline-neutral-normal-default'
        },
        indicatorColor: {
            brand: 'bg-layer-accent-prominent-fixed-default',
            danger: 'bg-layer-danger-prominent-fixed-default',
            success: 'bg-symbol-success',
            warning: 'bg-symbol-warning'
        }
    },
    defaultVariants: {
        variant: 'gradient',
        indicatorColor: 'brand'
    }
});
const Progress = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, indicatorColor, value, variant, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_progress_84970133__.Root, {
        className: cn(progressVariants({
            variant
        }), className),
        ref: ref,
        ...props,
        children: [
            !(0, __WEBPACK_EXTERNAL_MODULE_lodash__.isNil)(value) && value > 0 && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_progress_84970133__.Indicator, {
                className: cn(progressIndicatorVariants({
                    variant,
                    indicatorColor
                })),
                style: {
                    width: `${value || 0}%`
                }
            }),
            'bottom' === variant && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: "absolute top-0 h-full w-full rounded-b-lg outline -outline-offset-1 outline-neutral-normal-default"
            })
        ]
    }));
Progress.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_progress_84970133__.Root.displayName;
const progress_Progress = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Progress, {
        ref: ref,
        ...props
    }));
__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Root;
__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Group;
__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Value;
const SelectTrigger = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, children, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Trigger, {
        className: cn('flex h-8 w-full items-center justify-between rounded-md border border-neutral-normal-default px-3 py-2 text-neutral-subtle-active ring-offset-background hover:border-neutral-prominent-hover hover:bg-layer-neutral-normal-hover focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 data-placeholder:text-neutral-subtle-default [&>span]:line-clamp-1', className),
        ref: ref,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Icon, {
                asChild: true,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__phosphor_icons_react_e1aa837f__.CaretDown, {
                    className: "h-4 w-4 opacity-50"
                })
            })
        ]
    }));
SelectTrigger.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Trigger.displayName;
const SelectScrollUpButton = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.ScrollUpButton, {
        className: cn('flex cursor-default items-center justify-center py-1', className),
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__phosphor_icons_react_e1aa837f__.CaretUp, {
            className: "h-4 w-4"
        })
    }));
SelectScrollUpButton.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.ScrollUpButton.displayName;
const SelectScrollDownButton = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.ScrollDownButton, {
        className: cn('flex cursor-default items-center justify-center py-1', className),
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__phosphor_icons_react_e1aa837f__.CaretDown, {
            className: "h-4 w-4"
        })
    }));
SelectScrollDownButton.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.ScrollDownButton.displayName;
const SelectContent = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, children, position = 'popper', ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Portal, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Content, {
            className: cn('relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-layer-neutral-prominent-default text-neutral-normal-default shadow-md data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95', 'popper' === position && 'data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1', className),
            position: position,
            ref: ref,
            ...props,
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SelectScrollUpButton, {}),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Viewport, {
                    className: cn('p-1', 'popper' === position && 'h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]'),
                    children: children
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SelectScrollDownButton, {})
            ]
        })
    }));
SelectContent.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Content.displayName;
const SelectLabel = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Label, {
        className: cn('py-1.5 pr-2 pl-8 text-sm font-semibold', className),
        ref: ref,
        ...props
    }));
SelectLabel.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Label.displayName;
const SelectItem = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, children, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Item, {
        className: cn('relative flex w-full cursor-default items-center rounded-xs py-1.5 pr-2 pl-8 text-sm outline-hidden select-none focus:bg-layer-neutral-normal-hover focus:text-neutral-prominent-default data-disabled:pointer-events-none data-disabled:opacity-50', className),
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.ItemIndicator, {
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__phosphor_icons_react_e1aa837f__.Check, {
                        className: "h-4 w-4"
                    })
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.ItemText, {
                children: children
            })
        ]
    }));
SelectItem.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Item.displayName;
const SelectSeparator = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Separator, {
        className: cn('-mx-1 my-1 h-px bg-layer-neutral-subtle-default', className),
        ref: ref,
        ...props
    }));
SelectSeparator.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Separator.displayName;
const select_Select = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Root;
const select_SelectGroup = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Group;
const select_SelectValue = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Value;
const select_SelectTrigger = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SelectTrigger, {
        ref: ref,
        ...props
    }));
const select_SelectContent = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SelectContent, {
        ref: ref,
        ...props
    }));
const select_SelectLabel = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SelectLabel, {
        ref: ref,
        ...props
    }));
const select_SelectItem = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SelectItem, {
        ref: ref,
        ...props
    }));
const select_SelectSeparator = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SelectSeparator, {
        ref: ref,
        ...props
    }));
const select_SelectScrollUpButton = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SelectScrollUpButton, {
        ref: ref,
        ...props
    }));
const select_SelectScrollDownButton = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SelectScrollDownButton, {
        ref: ref,
        ...props
    }));
const Tabs = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_tabs_7bf5a77b__.Root;
const TabsList = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_tabs_7bf5a77b__.List, {
        className: cn('inline-flex items-center justify-center text-neutral-subtle-default', className),
        ref: ref,
        ...props
    }));
TabsList.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_tabs_7bf5a77b__.List.displayName;
const TabsTrigger = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_tabs_7bf5a77b__.Trigger, {
        className: cn("group relative inline-flex h-full items-center justify-center px-3 py-3.5 text-sm font-medium whitespace-nowrap ring-offset-background transition-all ring-inset after:absolute after:inset-x-0 after:bottom-0 after:h-0.5 after:content-[''] hover:text-neutral-prominent-hover hover:after:bg-layer-neutral-subtle-default focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden active:text-neutral-prominent-active active:after:bg-layer-accent-prominent-fixed-default disabled:pointer-events-none disabled:opacity-50 data-[state=active]:text-neutral-prominent-active data-[state=active]:after:bg-layer-accent-prominent-fixed-default", className),
        ref: ref,
        ...props
    }));
TabsTrigger.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_tabs_7bf5a77b__.Trigger.displayName;
const SectionTabsList = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_tabs_7bf5a77b__.List, {
        className: cn('inline-flex items-center justify-center gap-4 text-neutral-subtle-default', className),
        ref: ref,
        ...props
    }));
SectionTabsList.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_tabs_7bf5a77b__.List.displayName;
const SectionTabsTrigger = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_tabs_7bf5a77b__.Trigger, {
        className: cn("group relative inline-flex h-full items-center justify-center gap-2 px-0 py-3.5 text-sm font-medium whitespace-nowrap ring-offset-background transition-all ring-inset after:absolute after:inset-x-0 after:bottom-0 after:h-0.5 after:content-[''] hover:text-neutral-prominent-hover hover:after:bg-border focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden active:text-neutral-prominent-active active:after:bg-layer-accent-prominent-fixed-default disabled:pointer-events-none disabled:opacity-50 data-[state=active]:text-neutral-prominent-active data-[state=active]:after:bg-layer-accent-prominent-fixed-default", className),
        ref: ref,
        ...props
    }));
SectionTabsTrigger.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_tabs_7bf5a77b__.Trigger.displayName;
const FilterTabsList = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_tabs_7bf5a77b__.List, {
        className: cn('inline-flex items-center justify-center overflow-hidden rounded-md bg-layer-neutral-subtle-default text-neutral-normal ring-1 ring-border ring-inset', className),
        ref: ref,
        ...props
    }));
FilterTabsList.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_tabs_7bf5a77b__.List.displayName;
const FilterTabTrigger = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_tabs_7bf5a77b__.Trigger, {
        className: cn('inline-flex h-full items-center justify-center gap-2 rounded-md px-3 py-1 text-sm font-semibold whitespace-nowrap ring-offset-background transition-all hover:bg-layer-neutral-normal-hover focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-layer-neutral-prominent-default data-[state=active]:text-neutral-prominent data-[state=active]:shadow-sm data-[state=active]:ring-1 data-[state=active]:ring-border data-[state=active]:ring-inset', className),
        ref: ref,
        ...props
    }));
FilterTabTrigger.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_tabs_7bf5a77b__.Trigger.displayName;
const TabsContent = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_tabs_7bf5a77b__.Content, {
        className: cn('mt-6 ring-offset-background focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden', className),
        ref: ref,
        ...props
    }));
TabsContent.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_tabs_7bf5a77b__.Content.displayName;
const tabs_Tabs = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Tabs, {
        ref: ref,
        ...props
    }));
const tabs_SectionTabsList = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SectionTabsList, {
        ref: ref,
        ...props
    }));
const tabs_SectionTabsTrigger = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(SectionTabsTrigger, {
        ref: ref,
        ...props
    }));
const tabs_TabsContent = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TabsContent, {
        ref: ref,
        ...props
    }));
const tabs_TabsList = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TabsList, {
        ref: ref,
        ...props
    }));
const tabs_TabsTrigger = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TabsTrigger, {
        ref: ref,
        ...props
    }));
const tabs_FilterTabTrigger = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilterTabTrigger, {
        ref: ref,
        ...props
    }));
const tabs_FilterTabsList = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(FilterTabsList, {
        ref: ref,
        ...props
    }));
const Command = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command, {
        className: cn('flex h-full w-full flex-col overflow-hidden rounded-md bg-layer-neutral-prominent-default text-neutral-prominent-default', className),
        ref: ref,
        ...props
    }));
Command.displayName = __WEBPACK_EXTERNAL_MODULE_cmdk__.Command.displayName;
const CommandInput = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: cn('flex items-center border-b px-3'),
        "cmdk-input-wrapper": "",
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__phosphor_icons_react_e1aa837f__.MagnifyingGlass, {
                className: "mr-2 h-4 w-4 shrink-0 opacity-50"
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Input, {
                className: cn('flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-hidden placeholder:text-neutral-subtle-default disabled:cursor-not-allowed disabled:opacity-50', className),
                ref: ref,
                ...props
            })
        ]
    }));
CommandInput.displayName = __WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Input.displayName;
const CommandList = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command.List, {
        className: cn('max-h-[300px] overflow-x-hidden overflow-y-auto', className),
        ref: ref,
        ...props
    }));
CommandList.displayName = __WEBPACK_EXTERNAL_MODULE_cmdk__.Command.List.displayName;
const CommandEmpty = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef((props, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Empty, {
        className: "py-6 text-center text-sm",
        ref: ref,
        ...props
    }));
CommandEmpty.displayName = __WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Empty.displayName;
const CommandGroup = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Group, {
        className: cn('overflow-hidden p-1 text-neutral-prominent-default [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-neutral-subtle-default', className),
        ref: ref,
        ...props
    }));
CommandGroup.displayName = __WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Group.displayName;
const CommandSeparator = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Separator, {
        className: cn('-mx-1 h-px bg-border', className),
        ref: ref,
        ...props
    }));
CommandSeparator.displayName = __WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Separator.displayName;
const CommandItem = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Item, {
        className: cn("relative flex cursor-default items-center rounded-xs px-2 py-1.5 text-sm outline-hidden select-none hover:bg-layer-neutral-normal-hover aria-selected:bg-layer-neutral-normal-hover aria-selected:text-neutral-prominent-default data-[disabled='true']:pointer-events-none data-[disabled='true']:opacity-50", className),
        ref: ref,
        ...props
    }));
CommandItem.displayName = __WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Item.displayName;
const CommandShortcut = ({ className, ...props })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
        className: cn('ml-auto text-xs tracking-widest text-neutral-subtle-default', className),
        ...props
    });
CommandShortcut.displayName = 'CommandShortcut';
const Popover = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_popover_e2827c9f__.Root;
const PopoverAnchor = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_popover_e2827c9f__.PopoverAnchor;
const PopoverTriggerPrimitive = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_popover_e2827c9f__.Trigger;
const PopoverTrigger = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_popover_e2827c9f__.Trigger, {
        className: cn('cursor-pointer focus:ring-2 focus:ring-ring focus:ring-offset-1 focus:ring-offset-card focus-visible:border-input-border/10 focus-visible:outline-hidden dark:focus-visible:border-input-border/15', className),
        ref: ref,
        ...props
    }));
PopoverTrigger.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_popover_e2827c9f__.Trigger.displayName;
const PopoverContent = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ className, align = 'center', sideOffset = 4, ...props }, ref)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_popover_e2827c9f__.Portal, {
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_popover_e2827c9f__.Content, {
            align: align,
            className: cn('z-50 w-54 rounded-md border bg-layer-neutral-prominent-default p-4 text-neutral-normal-default shadow-md outline-hidden data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95', className),
            ref: ref,
            sideOffset: sideOffset,
            ...props
        })
    }));
PopoverContent.displayName = __WEBPACK_EXTERNAL_MODULE__radix_ui_react_popover_e2827c9f__.Content.displayName;
const skeletonVariants = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)('animate-pulse rounded-md bg-layer-neutral-subtle dark:bg-layer-white-subtle-fixed', {
    variants: {
        variant: {
            default: '',
            placeholder: 'animate-none'
        }
    },
    defaultVariants: {
        variant: 'default'
    }
});
function Skeleton({ className, variant, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: cn(skeletonVariants({
            variant
        }), className),
        ...props
    });
}
function optionToKey(option) {
    var _option_toKey;
    return (null == (_option_toKey = option.toKey) ? void 0 : _option_toKey.call(option)) ?? option.value;
}
const TypeaheadMultiFilter = ({ 'aria-label': ariaLabel, addon, allowNew = false, autoFocus = false, blurOnSelect = false, blurValue, children, className, clearOnBlur = false, defaultOpen, disabled, emptyMessage, isLoading = false, onBlur, onInputChange, onValueChange, optionClassName, options, placeholder, shouldFilter = true, shouldResetOnSelect = true, value })=>{
    const inputRef = (0, __WEBPACK_EXTERNAL_MODULE_react__.useRef)(null);
    const [isOpen, setOpen] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(defaultOpen ?? false);
    const [inputValue, setInputValue] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)('');
    const handleKeyDown = (event)=>{
        const input = inputRef.current;
        if (!input || 'Tab' === event.key) return;
        if (!isOpen) setOpen(true);
        if ('Enter' === event.key && '' !== input.value) {
            const optionToSelect = options.find((option)=>option.label === input.value);
            if (optionToSelect) null == onValueChange || onValueChange(optionToSelect);
        }
        if ('Escape' === event.key) {
            event.stopPropagation();
            input.blur();
        }
    };
    const handleBlur = ()=>{
        if (clearOnBlur) setInputValue('');
        setOpen(false);
        null == onBlur || onBlur();
    };
    const handleSelectOption = (selectedOption)=>{
        null == onValueChange || onValueChange(selectedOption);
        if (shouldResetOnSelect) setInputValue('');
        if (blurOnSelect) {
            var _inputRef_current;
            null == (_inputRef_current = inputRef.current) || _inputRef_current.blur();
        }
    };
    const handleInput = (event)=>{
        null == onInputChange || onInputChange(event.target.value);
    };
    const handleClearInput = ()=>{
        var _inputRef_current;
        setInputValue('');
        null == onInputChange || onInputChange('');
        null == (_inputRef_current = inputRef.current) || _inputRef_current.focus();
    };
    const showNewOption = allowNew && inputValue && !options.find((option)=>option.value === inputValue) && !(null == value ? void 0 : value.includes(inputValue));
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command, {
        className: cn('w-full', className),
        filter: (searchValue, search)=>{
            var _fuzzysort_single;
            return (null == (_fuzzysort_single = __WEBPACK_EXTERNAL_MODULE_fuzzysort__["default"].single(search, searchValue)) ? void 0 : _fuzzysort_single.score) ?? 0;
        },
        onKeyDown: handleKeyDown,
        shouldFilter: shouldFilter,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(Popover, {
            modal: true,
            onOpenChange: setOpen,
            open: isOpen,
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PopoverAnchor, {
                    asChild: true,
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                        className: "relative flex w-full flex-1 items-center justify-center gap-1.5",
                        children: [
                            addon,
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PopoverTriggerPrimitive, {
                                asChild: true,
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Input, {
                                    "aria-label": ariaLabel,
                                    asChild: !!children,
                                    autoFocus: autoFocus,
                                    className: "flex flex-1 border-transparent bg-transparent pr-8 text-sm text-neutral-subtle-active placeholder:text-neutral-subtle-default",
                                    disabled: disabled,
                                    onBlur: handleBlur,
                                    onInput: handleInput,
                                    onValueChange: setInputValue,
                                    placeholder: placeholder,
                                    ref: inputRef,
                                    value: isOpen ? inputValue : blurValue || '',
                                    children: children
                                })
                            }),
                            inputValue && !disabled && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Button, {
                                className: "absolute top-1/2 right-2 -translate-y-1/2",
                                onClick: handleClearInput,
                                size: "inline",
                                type: "button",
                                variant: "ghost",
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__phosphor_icons_react_e1aa837f__.XCircle, {
                                    className: "size-4"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PopoverContent, {
                    className: "w-[var(--radix-popover-trigger-width)] p-0",
                    onOpenAutoFocus: (event)=>{
                        event.preventDefault();
                    },
                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(CommandList, {
                        className: "flex overflow-y-hidden rounded-lg ring-1 ring-border [&>div]:flex [&>div]:w-full [&>div]:flex-col",
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                                className: "grow-1 overflow-y-auto",
                                children: [
                                    isLoading ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Loading, {
                                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                            className: "p-2",
                                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Skeleton, {
                                                className: "flex h-8 w-full items-center px-2 text-neutral-subtle",
                                                children: "Loading..."
                                            })
                                        })
                                    }) : null,
                                    options.length > 0 && !isLoading ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CommandGroup, {
                                        children: options.map((option)=>{
                                            const isSelected = null == value ? void 0 : value.includes(option.value);
                                            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(CommandItem, {
                                                "aria-checked": isSelected,
                                                className: cn('flex w-full items-center gap-2', {
                                                    'cursor-pointer': !disabled
                                                }),
                                                "data-disabled": disabled,
                                                onMouseDown: (event)=>{
                                                    event.preventDefault();
                                                    event.stopPropagation();
                                                },
                                                onSelect: ()=>handleSelectOption(option),
                                                role: "menuitemcheckbox",
                                                value: option.label,
                                                children: [
                                                    'string' == typeof option.icon ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("img", {
                                                        alt: option.label,
                                                        className: "w-4",
                                                        src: option.icon
                                                    }) : option.icon,
                                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                                                        className: cn('line-clamp-1 flex-1 break-all', optionClassName),
                                                        title: option.label,
                                                        children: option.label
                                                    }),
                                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Checkbox, {
                                                        checked: isSelected,
                                                        disabled: disabled,
                                                        onClick: (event)=>{
                                                            event.preventDefault();
                                                        }
                                                    })
                                                ]
                                            }, optionToKey(option));
                                        })
                                    }) : null,
                                    isLoading || showNewOption || (0, __WEBPACK_EXTERNAL_MODULE_lodash__.isNil)(emptyMessage) ? null : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_cmdk__.Command.Empty, {
                                        className: "rounded-xs px-2 py-3 text-center text-sm select-none",
                                        children: emptyMessage
                                    })
                                ]
                            }),
                            showNewOption && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(CommandGroup, {
                                className: "shrink-0 border-t",
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(CommandItem, {
                                    className: cn('flex w-full items-center gap-2', {
                                        'cursor-pointer': !disabled
                                    }),
                                    onMouseDown: (event)=>{
                                        event.preventDefault();
                                        event.stopPropagation();
                                    },
                                    onSelect: ()=>handleSelectOption({
                                            label: inputValue,
                                            value: inputValue
                                        }),
                                    value: inputValue,
                                    children: [
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__phosphor_icons_react_e1aa837f__.Plus, {}),
                                        ' Add "',
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                            className: "contents text-accent-normal-default",
                                            children: inputValue
                                        }),
                                        '"'
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const Typeahead = (props)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(TypeaheadMultiFilter, {
        ...props
    });
export { badge_Badge as Badge, breadcrumb_Breadcrumb as Breadcrumb, breadcrumb_BreadcrumbEllipsis as BreadcrumbEllipsis, breadcrumb_BreadcrumbItem as BreadcrumbItem, breadcrumb_BreadcrumbLink as BreadcrumbLink, breadcrumb_BreadcrumbList as BreadcrumbList, breadcrumb_BreadcrumbPage as BreadcrumbPage, breadcrumb_BreadcrumbSeparator as BreadcrumbSeparator, button_Button as Button, card_Card as Card, card_CardContent as CardContent, card_CardDescription as CardDescription, card_CardFooter as CardFooter, card_CardHeader as CardHeader, card_CardSubtitle as CardSubtitle, card_CardTitle as CardTitle, checkbox_Checkbox as Checkbox, src_dialog_Dialog as Dialog, dialog_DialogClose as DialogClose, src_dialog_DialogContent as DialogContent, dialog_DialogDescription as DialogDescription, dialog_DialogFooter as DialogFooter, dialog_DialogHeader as DialogHeader, dialog_DialogOverlay as DialogOverlay, dialog_DialogPortal as DialogPortal, dialog_DialogTitle as DialogTitle, dialog_DialogTrigger as DialogTrigger, tabs_FilterTabTrigger as FilterTabTrigger, tabs_FilterTabsList as FilterTabsList, input_Input as Input, label_Label as Label, loader_Loader as Loader, progress_Progress as Progress, tabs_SectionTabsList as SectionTabsList, tabs_SectionTabsTrigger as SectionTabsTrigger, select_Select as Select, select_SelectContent as SelectContent, select_SelectGroup as SelectGroup, select_SelectItem as SelectItem, select_SelectLabel as SelectLabel, select_SelectScrollDownButton as SelectScrollDownButton, select_SelectScrollUpButton as SelectScrollUpButton, select_SelectSeparator as SelectSeparator, select_SelectTrigger as SelectTrigger, select_SelectValue as SelectValue, tabs_Tabs as Tabs, tabs_TabsContent as TabsContent, tabs_TabsList as TabsList, tabs_TabsTrigger as TabsTrigger, Typeahead };
